import { __extends, __assign, __rest } from 'tslib';
import React__default, { createRef } from 'react';
import ReactNumberFormat from 'react-number-format';
import clsx from 'clsx';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import { ReactComponent as SvgTablerCircleX } from '../Icon/icons/tabler-circle-x.svg.js';
import { propTypes, defaultProps } from './NumberFormat.types.js';
import styles from './NumberFormat.module.scss.js';

var NumberFormat = /** @class */ (function (_super) {
    __extends(NumberFormat, _super);
    function NumberFormat(props) {
        var _this = _super.call(this, props) || this;
        _this.setInputRef = function (element) {
            var inputRef = _this.props.inputRef;
            _this.inputElement.current =
                element;
            if (inputRef) {
                if (typeof inputRef === 'function') {
                    inputRef(element);
                }
                else {
                    inputRef.current = element;
                }
            }
        };
        _this.handleClearInput = function (event) {
            event.preventDefault();
            event.stopPropagation();
            var _a = _this.props, onChange = _a.onChange, onValueChange = _a.onValueChange;
            var inputElement = _this.inputElement.current;
            var changeEvent = __assign(__assign({}, event), { currentTarget: inputElement, target: inputElement });
            changeEvent.target.value = '';
            onChange && onChange(changeEvent);
            onValueChange &&
                onValueChange({
                    floatValue: undefined,
                    formattedValue: '',
                    value: '',
                });
        };
        _this.inputElement = createRef();
        return _this;
    }
    NumberFormat.prototype.componentDidMount = function () {
        if (this.props.errorMessage) {
            console.warn('DEPRECATION WARNING: The `errorMessage` prop will be deprecated soon and support for it will be removed soon. Please use `secondaryCondition` instead.');
        }
        if (this.props.relativelyStyledConditions) {
            console.warn('DEPRECATION WARNING: Use isMultilineSecondaryCondition instead. `relativelyStyledConditions` is scheduled to be removed in the next major release');
        }
    };
    NumberFormat.prototype.render = function () {
        var _a = this.props, label = _a.label, isValid = _a.isValid, errorMessage = _a.errorMessage, clearable = _a.clearable, clearableAltText = _a.clearableAltText, className = _a.className, alignRight = _a.alignRight, variant = _a.variant, primaryCondition = _a.primaryCondition, secondaryCondition = _a.secondaryCondition, placeholder = _a.placeholder, relativelyStyledConditions = _a.relativelyStyledConditions, isSecondaryConditionMultiline = _a.isMultilineSecondaryCondition, inputProps = __rest(_a, ["label", "isValid", "errorMessage", "clearable", "clearableAltText", "className", "alignRight", "variant", "primaryCondition", "secondaryCondition", "placeholder", "relativelyStyledConditions", "isMultilineSecondaryCondition"]);
        var variantClass = styles["Input___" + variant];
        var isValidInput = isValid == null ? true : isValid;
        var value = this.props.value; // Don't move to props destruction, for inputProps to have correct value
        var hasValue = (value !== null && value !== undefined && value !== '') ||
            placeholder !== undefined;
        var validInputClass = hasValue ? styles.Input_validInput : '';
        var isMultilineSecondaryCondition = isSecondaryConditionMultiline || relativelyStyledConditions;
        var shouldShowSecondaryCondition = secondaryCondition ||
            !isValidInput ||
            isMultilineSecondaryCondition;
        return (React__default.createElement("div", { className: clsx(styles.Input, validInputClass, !isValidInput && styles.Input_errorInput, inputProps.disabled && styles.Input___disabled, variantClass, className) },
            React__default.createElement("div", { className: styles.Input_titleWrapper },
                React__default.createElement("label", { className: clsx(styles.Input_label, !label && styles.Input_label___hidden), htmlFor: 'input' }, label),
                primaryCondition && (React__default.createElement("div", { className: clsx(styles.Input_condition, styles.Input_condition___primary), "data-testid": 'primary-condition' }, primaryCondition))),
            React__default.createElement("div", { className: styles.Input_inputWrapper },
                React__default.createElement(ReactNumberFormat, __assign({ "aria-label": label, autoComplete: "off", name: "input", inputMode: "decimal", className: alignRight ? styles.AlignRight : '', placeholder: placeholder, getInputRef: this.setInputRef }, inputProps)),
                clearable && (React__default.createElement(ButtonBase, { onClick: this.handleClearInput, className: clsx(styles.Input_closeButton, shouldShowSecondaryCondition &&
                        styles.Input_closeButton___noBottomPadding, alignRight && styles.Input_closeButton___left), type: "button", tabIndex: -1, "data-testid": 'clear-input', title: clearableAltText || 'Clear Input' },
                    React__default.createElement(SvgTablerCircleX, null))
                // <IconButton
                //     disableBorder
                //     name="ClearSolidIcon"
                //     size={18}
                //     alt={clearableAltText || 'Clear Input'}
                //     onClick={this.handleClearInput}
                //     buttonProps={{
                //         type: 'button',
                //         tabIndex: -1,
                //     }}
                //     className={clsx(
                //         styles.Input_closeButton,
                //         shouldShowSecondaryCondition &&
                //             styles.Input_closeButton___noBottomPadding,
                //         alignRight && styles.Input_closeButton___left,
                //     )}
                // />
                )),
            shouldShowSecondaryCondition && (React__default.createElement("div", { className: clsx(styles.Input_condition, isMultilineSecondaryCondition
                    ? styles.Input_condition___relativeSecondary
                    : styles.Input_condition___secondary), "data-testid": "secondary-condition" }, secondaryCondition || errorMessage))));
    };
    NumberFormat.displayName = 'NumberFormat';
    NumberFormat.propTypes = propTypes;
    NumberFormat.defaultProps = __assign({}, defaultProps);
    return NumberFormat;
}(React__default.Component));

export { NumberFormat as default };
